module.exports = __webpack_public_path__ + "static/media/gng.ca8a0563.png";